import { Head } from "@inertiajs/react"
import { Sparkles } from "lucide-react"
import { AdminShell } from "@/components/AdminShell"

type Skill = {
  name: string
  description: string
}

export default function AdminSkills({ skills }: { skills: Skill[] }) {
  return (
    <>
      <Head title="Skills">
        <meta name="description" content="Project-level Claude Code skills available in this repo." />
        <meta property="og:title" content="Skills" />
        <meta property="og:description" content="Project-level Claude Code skills available in this repo." />
      </Head>
      <AdminShell>
        <div className="border-b border-hairline pb-6">
          <h1>Skills</h1>
          <p className="mt-1">
            Project-level Claude Code skills checked into this repo at <code>.claude/skills/</code>.
            Invoke any of them in a Claude Code session with <code>/&lt;name&gt;</code> or by saying its
            trigger phrase. This list is read live from the skill files — no manual updates needed.
          </p>
        </div>

        {skills.length === 0 ? (
          <div className="mt-6 rounded-lg border border-hairline bg-page p-6 text-ink-muted">
            No skills found under <code>.claude/skills/</code>.
          </div>
        ) : (
          <div className="mt-6 space-y-3">
            {skills.map((skill) => (
              <div key={skill.name} className="rounded-lg border border-hairline bg-page p-5">
                <div className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-surface">
                    <Sparkles className="h-4 w-4 text-ink-muted" />
                  </span>
                  <div className="min-w-0 flex-1">
                    <h3 className="font-mono">/{skill.name}</h3>
                    <p className="mt-1 text-ink-muted">{skill.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </AdminShell>
    </>
  )
}
